export default {
  nav: {
    home: "Inicio",
    lab: "Taller de reparación",
    phones: "Teléfonos",
    showroom: "Tienda",
    visit: "Visita y contacto",
    getEstimate: "Cotización",
    openMenu: "Abrir menú",
    closeMenu: "Cerrar menú",
    menu: "Menú",
    sound: "Sonido",
    call: "Llamar",
    tagline: "Reparación de teléfonos · Calgary",
  },
  status: {
    openNow: "Abierto ahora",
    closed: "Cerrado",
    until: "hasta las",
    opensToday: "abre hoy a las",
    opensTomorrow: "abre mañana a las",
    opensSunday: "abre el domingo a las",
  },
  hero: {
    h1a: "Tu tecnología rota,",
    h1b: "cuidadosamente",
    h1c: "devuelta a la vida.",
    sub: "Next-G Phone Repair repara teléfonos, portátiles y tecnología de todos los días en un taller real de Calgary — respuestas claras, trabajo cuidadoso, y nada empieza sin tu aprobación.",
    ctaQuote: "Obtener una cotización",
    ctaVisit: "Visitar la tienda",
    est: "Calgary, AB",
    badge: "Compra & Reparación",
  },
  marquee: [
    "Reparación de pantallas", "Cambio de batería", "Puertos de carga", "Daños por agua",
    "Módulos de cámara", "Recuperación de datos", "Cuidado de portátiles", "Rescate de software",
  ],
  process: {
    chapter: "01",
    eyebrow: "Nuestra forma de trabajar",
    title: "Cuatro pasos. Sin misterios, sin presión.",
    lede: "Cada reparación en Next-G sigue el mismo ritmo honesto — siempre sabes qué le pasa a tu dispositivo y cuánto costará.",
    steps: [
      { num: "01", title: "Tráelo", body: "Ven con el dispositivo tal como está — sin cita, sin empaque, sin formularios. Si se mojó, déjalo apagado y ven directo." },
      { num: "02", title: "Diagnosticamos", body: "Lo abrimos, probamos el hardware y te decimos en lenguaje claro qué falló de verdad — y qué no. Sin jerga, sin adivinanzas." },
      { num: "03", title: "Tú apruebas", body: "Recibes un precio claro en CAD antes de cualquier trabajo. Nada empieza sin tu sí — y si no vale la pena repararlo, también te lo decimos." },
      { num: "04", title: "De vuelta en tus manos", body: "Reparamos, probamos cada función otra vez y te entregamos el dispositivo funcionando — con la pieza vieja disponible si quieres verla." },
    ],
  },
  highlights: {
    chapter: "02",
    eyebrow: "Lo que reparamos",
    title: "Teléfonos, portátiles y todo lo que usas a diario.",
    items: [
      { title: "Reparación de teléfonos", body: "Pantallas, baterías, puertos, cámaras y daños por agua para iPhone y Android." },
      { title: "Reparación de portátiles", body: "MacBook y portátiles Windows — hardware, mejoras y rescate de sistemas lentos." },
      { title: "Soporte de software", body: "Bucles de arranque, actualizaciones fallidas, errores y problemas de cuentas resueltos con calma." },
      { title: "Diagnóstico de dispositivos", body: "¿No sabes qué pasa? Una inspección en el taller te dice exactamente qué ocurre." },
      { title: "Tienda de accesorios", body: "Fundas, protectores, cargadores, audio y equipo para creadores — ajustados en tienda." },
    ],
  },
  teaser: {
    chapter: "03",
    eyebrow: "Cotización en un minuto",
    titleA: "Elige el problema.",
    titleEm: "Luego llama",
    titleB: "— te cotizamos al momento.",
    body: "Elige tu dispositivo y el problema — luego llama a la tienda con esos detalles y obtén un precio claro y honesto al momento.",
    steps: ["Elige tu dispositivo", "Elige el problema", "Llama con los detalles"],
    ctaStart: "Empezar la cotización",
    ctaCall: "Llamar",
    pricesLabel: "Precios iniciales honestos",
    prices: ["Toda reparación desde CA $79", "Pantallas, baterías, puertos, cámaras y más", "Inspección gratis, siempre"],
  },
  location: {
    chapter: "04",
    eyebrow: "Encuentra la tienda",
    titleEm: "— junto a TD Bank.",
    lede: "Las visitas sin cita son bienvenidas. Trae el dispositivo tal como está y nosotros nos encargamos.",
    openMaps: "Abrir en Maps",
    visitContact: "Visita y contacto",
  },
  lab: {
    chapter: "El taller de reparación",
    eyebrow: "Servicios",
    titleA: "Cada reparación, explicada en",
    titleEm: "lenguaje claro.",
    lede: "Toca cualquier servicio para ver qué cubre y los síntomas que resuelve. Pedir una cotización siempre es gratis — y el trabajo siempre lo apruebas tú antes de empezar.",
    notice: "Quizás notes",
    ask: "Pedir una cotización",
    pricingTitle: "Cómo funcionan nuestros precios",
    pricingBody: "Los rangos en línea son cifras preliminares de referencia en CAD. El precio final se confirma tras inspeccionar el dispositivo, identificar el modelo exacto y revisar la disponibilidad de piezas — y el trabajo solo empieza con tu aprobación.",
    ctaTitleA: "¿No sabes cuál necesitas?",
    ctaTitleEm: "Solo pregunta.",
    ctaBody: "Describe lo que hace el dispositivo — te indicaremos la reparación correcta.",
    ctaQuote: "Obtener una cotización",
    ctaCall: "Llamar",
    services: {
      screen: {
        title: "Reparación de pantalla rota",
        blurb: "Vidrio agrietado, píxeles muertos, líneas en la pantalla o un táctil que dejó de responder. Reemplazamos pantallas de teléfonos, tabletas y portátiles con piezas de calidad equivalente.",
        symptoms: ["Vidrio agrietado o destrozado", "El táctil no responde", "Líneas, manchas o zonas negras", "Pantalla negra pero el teléfono vibra"],
      },
      battery: {
        title: "Cambio de batería",
        blurb: "Si tu teléfono muere al 30 %, se apaga con el frío o vive conectado al cargador, una batería nueva suele resolverlo. Salud verificada antes y después.",
        symptoms: ["La batería se agota en horas", "Apagados aleatorios", "Batería hinchada que levanta la pantalla", "Solo funciona enchufado"],
      },
      charging: {
        title: "Problemas de puerto de carga",
        blurb: "Cables flojos, carga lenta o un teléfono que solo carga en cierto ángulo. Limpiamos, reparamos o reemplazamos puertos de carga y rastreamos fallas de energía hasta la placa.",
        symptoms: ["El cable queda flojo o se cae", "Solo carga en cierto ángulo", "No carga en absoluto", "La carga inalámbrica funciona, el puerto no"],
      },
      backglass: {
        title: "Vidrio trasero y carcasa dañados",
        blurb: "Un vidrio trasero agrietado y un marco doblado no son solo estéticos — dejan entrar polvo y humedad. Reemplazamos el vidrio trasero y restauramos la carcasa para sellar el dispositivo.",
        symptoms: ["Vidrio trasero agrietado o destrozado", "Bordes filosos al sostenerlo", "Marco doblado o abollado", "Aro de cámara flojo o con holgura"],
      },
      camera: {
        title: "Reparación y cambio de cámara",
        blurb: "Fotos borrosas, lente que tiembla, enfoque que falla o una app de cámara que abre en negro. Reemplazamos vidrios de lente y módulos de cámara, delante y detrás.",
        symptoms: ["Fotos siempre borrosas", "La cámara tiembla o suena", "Pantalla negra en la app de cámara", "Vidrio de lente agrietado"],
      },
      water: {
        title: "Evaluación de daños por agua",
        blurb: "El líquido dentro de un dispositivo es una carrera contra la corrosión. Tráelo apagado — lo abrimos, limpiamos la corrosión y evaluamos qué se puede salvar antes de cotizar.",
        symptoms: ["Se cayó al agua o se derramó líquido", "Pantalla parpadea tras mojarse", "El teléfono murió tras el líquido", "Humedad bajo la cámara o la pantalla"],
      },
      software: {
        title: "Software, errores y arranque",
        blurb: "Atascado en el logo, actualizaciones fallidas, errores constantes o cuentas bloqueadas. Resolvemos problemas de software, restauramos sistemas y te ayudamos a recuperar tu dispositivo.",
        symptoms: ["Atascado en el logo de inicio", "Actualización fallida y no arranca", "Las apps fallan constantemente", "Bloqueado fuera de tus cuentas"],
      },
      data: {
        title: "Recuperación de datos y acceso",
        blurb: "Fotos, contactos y archivos atrapados en un dispositivo muerto o dañado. Recuperamos datos de teléfonos y portátiles siempre que el hardware lo permita — incluso si el dispositivo no enciende.",
        symptoms: ["No enciende pero los datos importan", "Fotos o archivos atrapados en un teléfono roto", "Contraseña olvidada", "Disco de portátil fallando"],
      },
      laptop: {
        title: "Soporte de hardware y software para portátiles",
        blurb: "Pantallas, teclados, baterías, almacenamiento, sistemas lentos y limpieza de virus — MacBook y Windows reciben el mismo cuidado que los teléfonos.",
        symptoms: ["Pantalla de portátil agrietada", "Teclas muertas o escriben mal", "Portátil de repente muy lento", "No carga o no retiene la carga"],
      },
      diagnostics: {
        title: "Diagnóstico y consulta de reparación",
        blurb: "¿No sabes qué tiene? Tráelo. Inspeccionamos el dispositivo, te explicamos en lenguaje claro qué pasa y cotizamos la reparación antes de cualquier trabajo.",
        symptoms: ["Algo anda mal pero no sabes qué", "Segunda opinión sobre otra cotización", "Dispositivo viejo — ¿vale la pena?", "Varios problemas a la vez"],
      },
      cleaning: {
        title: "Limpieza profunda",
        blurb: "La pelusa de los bolsillos, el polvo y la suciedad tapan poco a poco bocinas, puertos y botones. Abrimos el dispositivo y lo limpiamos por dentro y por fuera — suele arreglar el sonido apagado y los botones pegajosos.",
        symptoms: ["Bocinas apagadas o bajas", "Puerto de carga lleno de pelusa", "Botones pegajosos o atascados", "Polvo bajo el vidrio de la cámara"],
      },
    },
  },
  fixboth: {
    eyebrow: "Teléfonos y portátiles",
    title: "Teléfono roto. Portátil roto. Un solo lugar.",
    steps: [
      "iPhone 17 Pro Max — pantalla y parte trasera agrietadas",
      "Portátiles Windows — HP, Dell y más",
      "MacBook — pantallas, baterías y teclados",
      "Sal con él funcionando como nuevo",
    ],
    cta: "Pedir una cotización",
  },
  buy: {
    shopLink: "Ver los teléfonos",
    eyebrow: "Teléfonos nuevos y usados",
    titleA: "Comprar y",
    titleEm: "Reparar",
    titleB: "— una tienda, todo cubierto.",
    lede: "Vendemos teléfonos nuevos y usados — Samsung, iPhone y Google Pixel — todos probados, activados y listos para usar. Usado significa solo excelente condición.",
    perks: [
      { title: "Garantía de 6 a 12 meses", body: "Cada teléfono incluye de 6 meses hasta un año completo de garantía." },
      { title: "Protector + funda gratis", body: "Un protector de pantalla templado de alta calidad y una funda, gratis con cada teléfono que compres." },
      { title: "Descuentos por volver", body: "Cada compra te suma a descuentos futuros — entre más compras, más ahorras." },
      { title: "Probado y activado", body: "Totalmente probado, activado y listo para usar al salir de la tienda." },
    ],
    bestPrice: "Los mejores precios en teléfonos de Calgary y Edmonton — de verdad, en todo Alberta.",
    brandsTitle: "Lo que tenemos",
    seriesNote: "…y más en la tienda. Llama para saber el stock de hoy.",
    cta: "Llama por el stock de hoy",
    iphoneLine: "iPhone 5 en adelante",
    pixelLine: "Pixel 6 en adelante",
  },
  showroom: {
    chapter: "La tienda",
    eyebrow: "Accesorios y tecnología diaria",
    titleA: "Un estante pequeño y",
    titleEm: "cuidadosamente elegido",
    titleB: "— no un almacén.",
    lede: "Fundas, protección, energía y audio, elegidos para la vida diaria. Todo puede ajustarse o probarse en tu propio dispositivo en el mostrador.",
    groups: { all: "Todo", phones: "Teléfonos", protection: "Protección", power: "Energía", audio: "Audio", wearables: "Relojes", car: "Auto", studio: "Estudio" },
    availability: "Disponibilidad y precios confirmados en tienda",
    stripEyebrow: "Ven a verlo en persona",
    stripTitle: "El estante cambia seguido — mirar no cuesta nada.",
    stripVisit: "Planea tu visita",
    stripQuote: "Obtener una cotización",
    items: {
      phones: { title: "Teléfonos nuevos y usados", blurb: "Samsung, iPhone y Google Pixel — probados, activados y listos para usar, con 6 meses hasta un año de garantía." },
      cases: { title: "Fundas de teléfono", blurb: "Fundas delgadas, resistentes y transparentes ajustadas a tu modelo exacto — pruébalas en tienda." },
      protectors: { title: "Protectores y protección de cámara", blurb: "Vidrio templado y de privacidad, más protección de lente — instalados en el mostrador mientras esperas." },
      cables: { title: "Cables y cargadores rápidos", blurb: "Cables trenzados USB-C y Lightning, más cargadores rápidos de calidad para iPhone, Android y tabletas." },
      power: { title: "Baterías externas y cargadores", blurb: "Cargadores de pared rápidos, cargadores inalámbricos, hubs multipuerto y baterías externas para viajes." },
      car: { title: "Gadgets para el auto", blurb: "Soportes y monturas de teléfono, más cargadores de auto con cable e inalámbricos para cada dispositivo." },
      audio: { title: "AirPods y audífonos", blurb: "AirPods, audífonos inalámbricos y de diadema — escucha diaria, resuelta." },
      speakers: { title: "Mini bocinas inalámbricas", blurb: "Bocinas portátiles listas para exteriores, con gran sonido en cuerpo pequeño." },
      smartwatches: { title: "Smartwatches económicos", blurb: "Relojes para el día a día que miden el ritmo cardíaco, cuentan pasos y se conectan a tu teléfono." },
      memory: { title: "Tarjetas de memoria", blurb: "Tarjetas microSD en todas las capacidades, para teléfonos, cámaras y tabletas." },
      keyboards: { title: "Teclados", blurb: "Teclados con cable e inalámbricos para trabajar, estudiar y jugar." },
      creatorkit: { title: "Kits de creación de contenido", blurb: "Aros de luz, trípodes portátiles y de pie, y mucho más para creadores." },
      creator: { title: "Equipo para creadores y oficina en casa", blurb: "Trípodes, soportes, aros de luz y pequeñas mejoras de escritorio para llamadas, clases y contenido." },
      addons: { title: "Accesorios para teléfono y portátil", blurb: "Soportes, fundas, hubs y las pequeñas cosas que hacen tu dispositivo más fácil de usar." },
      preowned: { title: "Dispositivos y repuestos", blurb: "Pregunta en el mostrador por dispositivos y piezas de repuesto disponibles en el estante." },
    },
  },
  visit: {
    chapter: "Visita y contacto",
    eyebrow: "Ven a vernos",
    titleA: "La tienda en 17th Ave SE,",
    titleEm: "justo junto a TD Bank.",
    lede: "Las visitas sin cita son bienvenidas en horario de atención. Trae el dispositivo tal como está — no necesitas cita.",
    addressLabel: "Dirección",
    hoursLabel: "Horario de atención",
    call: "Llamar",
    text: "Enviar texto a la tienda",
    email: "Escríbenos",
    openMaps: "Abrir en Maps",
    planEyebrow: "¿Prefieres planear primero?",
    planTitle: "Obtén una cotización preliminar antes de hacer el viaje.",
    planCta: "Obtener una cotización",
    mapTitle: "Mapa a Next-G Phone Repair",
  },
  quote: {
    eyebrow: "Cotización de reparación",
    titleA: "Un número claro,",
    titleEm: "en cerca de un minuto.",
    lede: "Tres elecciones rápidas nos dicen qué pasa. Luego llama — te damos un precio claro al momento, aprobado por ti antes de cualquier trabajo.",
    step: "Paso",
    of: "de",
    stepTitle1: "¿Qué reparamos?",
    stepTitle2: "¿Qué generación, más o menos?",
    stepTitle3: "¿Qué le pasa?",
    back: "Atrás",
    preliminary: "Cotización preliminar",
    planning: "rango de referencia",
    factorsTitle: "Qué define el precio final",
    factors: [
      "El modelo exacto y la calidad de pieza disponible",
      "Qué tanto se extendió el daño dentro del dispositivo",
      "Disponibilidad de piezas y precios de proveedores de esa semana",
      "Cualquier problema extra encontrado en la inspección gratuita",
    ],
    disclaimer: "Este es un rango preliminar y no vinculante. Las piezas, el modelo exacto, el diagnóstico y la disponibilidad pueden cambiar el precio final — siempre confirmado contigo antes de empezar.",
    call: "Llamar",
    text: "Enviar esta cotización por texto",
    email: "Escribir a la tienda",
    startOver: "Empezar de nuevo",
    visitShop: "Visitar la tienda",
    categories: {
      iphone: { label: "iPhone", blurb: "Todas las generaciones, del iPhone 8 a los últimos modelos Pro." },
      android: { label: "Teléfono Android", blurb: "Samsung, Google Pixel y otros dispositivos Android." },
      tablet: { label: "Tableta", blurb: "iPad y tabletas Android de todos los tamaños." },
      laptop: { label: "Portátil", blurb: "MacBook y portátiles Windows, hardware y software." },
    },
    tiers: {
      iphone: {
        older: { label: "iPhone antiguo", hint: "iPhone 8, X y generación SE" },
        recent: { label: "iPhone reciente", hint: "Generación iPhone 11 a 14" },
        newest: { label: "iPhone nuevo / Pro", hint: "iPhone 15 a 17 y modelos Pro" },
      },
      android: {
        standard: { label: "Android estándar", hint: "Teléfonos de gama baja y media" },
        recent: { label: "Android reciente", hint: "Modelos recientes comunes" },
        flagship: { label: "Android gama alta", hint: "Galaxy S / Ultra, Pixel Pro y similares" },
      },
      tablet: {
        standard: { label: "Tableta estándar", hint: "Tabletas comunes y antiguas" },
        recent: { label: "Tableta reciente", hint: "Modelos iPad y Android recientes" },
        pro: { label: "Tableta Pro", hint: "iPad Pro y tabletas grandes premium" },
      },
      laptop: {
        standard: { label: "Portátil estándar", hint: "Portátiles comunes y antiguos" },
        recent: { label: "Portátil reciente", hint: "Modelos recientes comunes y ultrabooks" },
        pro: { label: "Portátil gamer / Pro", hint: "Portátiles gamer, MacBook Pro y estaciones de trabajo" },
      },
    },
    issues: {
      screen: { label: "Pantalla rota", hint: "Grietas, píxeles muertos o problemas táctiles" },
      battery: { label: "Cambio de batería", hint: "Descarga rápida, apagados, hinchazón o mala salud" },
      charging: { label: "Problema de carga", hint: "Puerto flojo, no carga o carga intermitente" },
      backglass: { label: "Vidrio trasero roto", hint: "Vidrio trasero agrietado o carcasa dañada" },
      camera: { label: "Problema de cámara", hint: "Lente dañada, enfoque fallido o módulo dañado" },
      water: { label: "Daños por agua", hint: "Contacto con líquido, corrosión o no enciende" },
      software: { label: "Problema de software", hint: "Errores, actualizaciones, arranque o cuentas" },
      data: { label: "Recuperación de datos", hint: "Fotos, archivos o acceso al dispositivo" },
    },
    smsBody: "Hola Next-G, llamo por una reparación. Dispositivo: {device}. Problema: {issue}.",
    emailSubject: "Solicitud de reparación — Next-G",
    resultTitle: "Listo — ahora solo llama.",
    callNow: "Llamar ahora",
    callLead: "Cada reparación es distinta, así que cotizamos en vivo en vez de adivinar en línea. Llama con estos detalles y tendrás una respuesta clara al momento.",
    readyTitle: "Ten esto listo al llamar",
    ready: ["Tu modelo exacto, si lo sabes", "Qué hace — o deja de hacer — el dispositivo", "Cuándo empezó el problema"],
    noPrice: "Nada empieza sin tu aprobación. El precio que te den en la llamada es el que tú aceptas.",
  },
  footer: {
    explore: "Explorar",
    talk: "Contáctanos",
    hours: "Horario",
    quote: "Cotización",
    rights: "Calgary, Alberta",
    line: "Visitas sin cita bienvenidas · Cotizaciones confirmadas antes de cualquier trabajo",
    motto: "Servicio de nueva generación para la nueva generación.",
  },
};
